module.exports = __webpack_public_path__ + "img/DAVID_CANNON_05-rs.64ed7cba.jpg";